import React from 'react';

interface FamilyDetailTabProps {
  employeeData: any;
}

const formatRelationship = (relationship: string | null | undefined) => {
  if (!relationship) return '-';
  const relationshipMap: Record<string, string> = {
    spouse: 'Suami/Istri',
    child: 'Anak',
    parent: 'Orang Tua',
    sibling: 'Saudara',
  };
  return relationshipMap[relationship] || relationship;
};

const formatGender = (gender: string | null | undefined) => {
  if (!gender) return '-';
  return gender === 'male' ? 'Laki-laki' : gender === 'female' ? 'Perempuan' : gender;
};

export default function FamilyDetailTab({ employeeData }: FamilyDetailTabProps) {
  const familyMembers = employeeData.family_members || [];

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold">Data Keluarga Inti</h3>
        <p className="text-gray-500 text-sm">Informasi anggota keluarga pegawai</p>
      </div>

      {familyMembers.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          <p>Tidak ada data anggota keluarga</p>
        </div>
      ) : (
        <div className="space-y-4">
          {familyMembers.map((member: any, index: number) => (
            <div key={index} className="border-2 rounded-lg p-4 space-y-3 bg-gray-50">
              <h4 className="font-medium text-gray-900">Anggota Keluarga #{index + 1}</h4>
              <div className="grid md:grid-cols-2 gap-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nama</label>
                  <div className="px-3 py-2 bg-white border border-gray-200 rounded-md text-gray-900">
                    {member.name || '-'}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Hubungan</label>
                  <div className="px-3 py-2 bg-white border border-gray-200 rounded-md text-gray-900">
                    {formatRelationship(member.relationship)}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">NIK</label>
                  <div className="px-3 py-2 bg-white border border-gray-200 rounded-md text-gray-900 font-mono">
                    {member.nik || '-'}
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Jenis Kelamin
                  </label>
                  <div className="px-3 py-2 bg-white border border-gray-200 rounded-md text-gray-900">
                    {formatGender(member.gender)}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
